import Default from 'apps/company/layouts/Default';
import * as React from 'react';
import { Navigate } from 'react-router-dom';
import RouteName from 'config/routes';
import { useSelector } from 'react-redux';
import { useGetCampaignNotificationQuery } from 'services/company/systemSetting';
import notFoundSelector from 'selectors/notFoundSelector';
import campaignNotificationSelector from 'selectors/campaignNotificationSelector';

const ProtectedRoutes = () => {
  const { isError: isErrorCampaignNotification } = useGetCampaignNotificationQuery();
  useSelector(campaignNotificationSelector);

  const notFound = useSelector(notFoundSelector);

  if (notFound) {
    return <Navigate to={RouteName.notFound} />
  }

  return !isErrorCampaignNotification ? (
    <Default />
  ) : (
    <Navigate to={RouteName.loginCompany} />
  );
};

export default ProtectedRoutes;
